import { Fragment } from 'react'
import { X } from 'react-feather'
import { NavLink } from 'react-router-dom'

import { RouteKey, ROUTES } from '@routes'

import { MenuItem } from './MenuItem'
import * as S from './MobileMenu.styles'

interface MenuProps {
  isOpen: boolean
  items: RouteKey[]
  onSelect: () => void
  onClose?: () => void
}

export function Menu({ isOpen, items, onSelect, onClose }: MenuProps) {
  return (
    <S.MenuContainer className={isOpen ? 'is-open' : ''}>
      <S.LogoContainer>
        <NavLink to={ROUTES.dashboard.path}>
          <S.MobileLogo />
        </NavLink>
      </S.LogoContainer>
      <S.MenuItemsContainer>
        <S.MenuItemsList>
          {items.map((route, key) => {
            const Icon = ROUTES[route].icon || Fragment

            return (
              <MenuItem
                key={key}
                route={route}
                title={ROUTES[route].title}
                icon={<Icon />}
                onSelect={onSelect}
              />
            )
          })}
        </S.MenuItemsList>
      </S.MenuItemsContainer>
      <S.Footer>
        {isOpen && onClose ? (
          <S.CloseMenuButton>
            <X onClick={onClose} />
          </S.CloseMenuButton>
        ) : null}
      </S.Footer>
    </S.MenuContainer>
  )
}
